
// import { useState, useEffect } from "react";

// import {
//   ArrowRight,
//   Newspaper,
//   FileText,
//   Globe2,
//   Building2,
//   Mic2,
// } from "lucide-react";

// import heroBg from "../assets/hero-bg.png";
// import { fetchBanners } from "../api/bannerApi";
// import { fetchTicker } from "../api/tickerApi";

// const TICKER_ICONS = [Globe2, FileText, Newspaper, Building2, Mic2];

// export default function HeroSection() {
//   // ---- Ticker Data (ab DB se aata hai) ----
//   const [tickerRaw, setTickerRaw] = useState([]);
//   const [tickerLoading, setTickerLoading] = useState(true);

//   useEffect(() => {
//     let isMounted = true;

//     fetchTicker()
//       .then((items) => {
//         if (!isMounted) return;
//         setTickerRaw(items);
//       })
//       .catch((err) => {
//         console.error("Failed to load ticker:", err);
//       })
//       .finally(() => {
//         if (isMounted) setTickerLoading(false);
//       });

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const tickerData = tickerRaw.map((item, i) => ({
//     text: item.text,
//     link: item.link,
//     isPdf: item.isPdf,
//     icon: TICKER_ICONS[i % TICKER_ICONS.length],
//   }));

//   const horizontalTicker =
//     tickerData.length > 0 ? [...tickerData, ...tickerData] : [];

//   // ---- Slider Data (banners, DB se aata hai) ----
//   const [originalCards, setOriginalCards] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     let isMounted = true;

//     fetchBanners()
//       .then((banners) => {
//         if (!isMounted) return;
//         const mapped = banners.map((b) => ({
//           img: b.image,
//           title: b.title,
//           date: "",
//           link: b.link,
//         }));
//         setOriginalCards(mapped);
//       })
//       .catch((err) => {
//         console.error("Failed to load banners:", err);
//       })
//       .finally(() => {
//         if (isMounted) setLoading(false);
//       });

//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const cards =
//     originalCards.length > 0 ? [...originalCards, originalCards[0]] : [];

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isTransitioning, setIsTransitioning] = useState(true);
//   const [isPaused, setIsPaused] = useState(false);

//   useEffect(() => {
//     if (isPaused || cards.length === 0) return;
//     const timer = setInterval(() => handleNext(), 5000);
//     return () => clearInterval(timer);
//   }, [isPaused, currentIndex, cards.length]);

//   const handleNext = () => {
//     setIsTransitioning(true);
//     setCurrentIndex((prev) => prev + 1);
//   };

//   const handleTransitionEnd = () => {
//     if (currentIndex >= cards.length - 1) {
//       setIsTransitioning(false);
//       setCurrentIndex(0);
//       setTimeout(() => setIsTransitioning(true), 50);
//     }
//   };

//   return (
//     <section
//       className="relative mb-20 bg-no-repeat bg-bottom"
//       style={{
//         background: "#FAF7F2",
//         backgroundSize: "cover",
//         backgroundPosition: "center bottom",
//         backgroundAttachment: "fixed",
//       }}
//     >
//       <div className="mx-auto px-6 py-20 lg:py-10">
//         <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
//           {/* LEFT CONTENT */}
//           <div className="space-y-6">
//             <h1 className="text-5xl lg:text-4xl font-bold leading-tight text-gray-900">
//               The Voice of <span className="text-[#da2128]">Indian Industry</span>
//             </h1>

//             <h2 className="text-4xl lg:text-4xl font-semibold text-[#faa61a] leading-tight !mt-[10px]">
//               Shaping Bharat's Future
//             </h2>

//             <p className="text-[18px] text-gray-600 max-w-lg">
//               The Associated Chambers of Commerce & Industry of India (ASSOCHAM) has been at the forefront of strengthening India's economic landscape for over a century.
//             </p>

//             <div className="flex flex-wrap gap-4 pt-4">
//               <a
//                 href="#about-us"
//                 className="inline-flex items-center gap-2 px-8 py-3.5 hover:bg-[#f59c00] hover:text-white  font-semibold rounded-xl border-2 border-[#f7941d] hover:border-white transition-all duration-300"
//               >
//                 Explore
//                 <ArrowRight className="w-5 h-5" />
//               </a>
//             </div>
//           </div>

//           {/* RIGHT SIDE - SLIDER */}
//           <div className="relative">
//             <div
//               className="relative rounded-3xl overflow-hidden shadow-2xl"
//               style={{ boxShadow: "2px 2px 2px 2px #9c9999" }}
//               onMouseEnter={() => setIsPaused(true)}
//               onMouseLeave={() => setIsPaused(false)}
//             >
//               <div className="relative h-[430px] lg:h-[440px] rounded-3xl">
//                 {loading && (
//                   <div className="flex items-center justify-center h-full w-full bg-gray-100 animate-pulse text-gray-400 text-sm">
//                     Loading...
//                   </div>
//                 )}

//                 {!loading && cards.length === 0 && (
//                   <div className="flex items-center justify-center h-full w-full bg-gray-100 text-gray-400 text-sm">
//                     No banners found
//                   </div>
//                 )}

//                 {!loading && cards.length > 0 && (
//                   <div
//                     className="flex h-full w-full"
//                     onTransitionEnd={handleTransitionEnd}
//                     style={{
//                       transform: `translateX(-${currentIndex * 100}%)`,
//                       transition: isTransitioning
//                         ? "transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
//                         : "none",
//                     }}
//                   >
//                     {cards.map((card, i) => (
//                       <div key={i} className="relative h-full w-full shrink-0">
//                         <img
//                           src={card.img}
//                           alt={card.title}
//                           className="w-full h-full "
//                           loading="eager"
//                         />
//                         <div className="absolute inset-0 " />
//                         <div className="absolute bottom-3 left-5 right-5 text-white">
//                           <div className="font-serif text-xs lg:text-sm leading-snug bg-black/60 backdrop-blur-md px-2.5 py-1.5 rounded-md inline-block">
//                             {card.title}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Bottom Floating Ticker */}
//       <div className="absolute bottom-0 left-0 w-full z-20 translate-y-1/2 px-6">
//         <div className="max-w-8xl mx-auto">
//           <div className="bg-[#FFFFFF] backdrop-blur-xl border border-[#FFFFFF] shadow-2xl rounded-2xl overflow-hidden">
//             <div className="flex items-center pr-[18px]">
//               {/* LIVE UPDATE LABEL */}
//               <div className="bg-[#da2128]/50 hover:bg-[#da2128] hover:text-white px-4 py-4 flex items-center gap-2 font-semibold text-xs sm:text-sm whitespace-nowrap rounded-r-2xl shadow-lg min-w-fit ">
//                 <span className="w-2 h-2 bg-[#FFFFFF] rounded-full animate-pulse" />
//                 LIVE UPDATES
//               </div>

//               {/* TICKER */}
//               <div className="flex-1 overflow-hidden px-4">
//                 {tickerLoading && (
//                   <div className="py-3 text-sm text-gray-400">Loading updates...</div>
//                 )}

//                 {!tickerLoading && horizontalTicker.length === 0 && (
//                   <div className="py-3 text-sm text-gray-400">No updates found</div>
//                 )}

//                 {!tickerLoading && horizontalTicker.length > 0 && (
//                   <div className="flex items-center gap-8 whitespace-nowrap animate-[tickerHorizontal_40s_linear_infinite] hover:[animation-play-state:paused] py-3">
//                     {horizontalTicker.map((item, i) => {
//                       const Icon = item.icon;

//                       return (
//                         <a
//                           key={i}
//                           href={item.link || "#knowledge"}
//                           target={item.link ? "_blank" : undefined}
//                           rel={item.link ? "noopener noreferrer" : undefined}
//                           className="flex items-center gap-2 text-gray-700 hover:text-[#B5121B] transition-colors m-[5px]"
//                         >
//                           <Icon className="w-4 h-4" />
//                           <span className="text-sm font-medium">{item.text}</span>
//                           {item.isPdf && (
//                             <span className="text-[10px] font-bold text-[#da2128] border border-[#da2128] rounded px-1 leading-4">
//                               PDF
//                             </span>
//                           )}
//                         </a>
//                       );
//                     })}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @keyframes tickerHorizontal {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(-50%);
//           }
//         }
//       `}</style>
//     </section>
//   );
// }







// new new code 




import { useState, useEffect } from "react";

import {
  ArrowRight,
  ChevronLeft,
  ChevronRight,
  Newspaper,
  FileText,
  Globe2,
  Building2,
  Mic2,
} from "lucide-react";

import heroBg from "../assets/hero-bg.png";
import { fetchBanners } from "../api/bannerApi";
import { fetchTicker } from "../api/tickerApi";

const TICKER_ICONS = [Globe2, FileText, Newspaper, Building2, Mic2];

export default function HeroSection() {
  // ---- Ticker Data (ab DB se aata hai) ----
  const [tickerRaw, setTickerRaw] = useState([]);
  const [tickerLoading, setTickerLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchTicker()
      .then((items) => {
        if (!isMounted) return;
        setTickerRaw(items);
      })
      .catch((err) => {
        console.error("Failed to load ticker:", err);
      })
      .finally(() => {
        if (isMounted) setTickerLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const tickerData = tickerRaw.map((item, i) => ({
    text: item.text,
    link: item.link,
    isPdf: item.isPdf,
    icon: TICKER_ICONS[i % TICKER_ICONS.length],
  }));

  const horizontalTicker =
    tickerData.length > 0 ? [...tickerData, ...tickerData] : [];

  // ---- Slider Data (banners, DB se aata hai) ----
  const [originalCards, setOriginalCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    fetchBanners()
      .then((banners) => {
        if (!isMounted) return;
        const mapped = banners.map((b) => ({
          img: b.image,
          title: b.title,
          date: "",
          link: b.link,
        }));
        setOriginalCards(mapped);
      })
      .catch((err) => {
        console.error("Failed to load banners:", err);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  // Build infinite loop cards: [last, ...originals, first]
  const cards =
    originalCards.length > 0
      ? [originalCards[originalCards.length - 1], ...originalCards, originalCards[0]]
      : [];

  const [currentIndex, setCurrentIndex] = useState(1); // start at first real slide (index 1)
  const [isTransitioning, setIsTransitioning] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  // Auto-play
  useEffect(() => {
    if (isPaused || cards.length === 0) return;
    const timer = setInterval(() => handleNext(), 5000);
    return () => clearInterval(timer);
  }, [isPaused, currentIndex, cards.length]);

  // Next slide
  const handleNext = () => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev + 1);
  };

  // Previous slide
  const handlePrev = () => {
    setIsTransitioning(true);
    setCurrentIndex((prev) => prev - 1);
  };

  // Handle loop wrap-around without transition
  const handleTransitionEnd = () => {
    const lastIndex = cards.length - 1;
    // If we're at the cloned first slide (index = lastIndex), jump to real first (index 1)
    if (currentIndex === lastIndex) {
      setIsTransitioning(false);
      setCurrentIndex(1);
      setTimeout(() => setIsTransitioning(true), 50);
    }
    // If we're at the cloned last slide (index = 0), jump to real last (index = originalCards.length)
    else if (currentIndex === 0) {
      setIsTransitioning(false);
      setCurrentIndex(originalCards.length);
      setTimeout(() => setIsTransitioning(true), 50);
    }
  };

  return (
    <section
      className="relative mb-20 bg-no-repeat bg-bottom"
      style={{
        background: "#FAF7F2",
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundAttachment: "fixed",
      }}
    >
      <div className="mx-auto px-6 py-20 lg:py-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* LEFT CONTENT */}
          <div className="space-y-6">
            <h1 className="text-5xl lg:text-4xl font-bold leading-tight text-gray-900">
              The Voice of <span className="text-[#da2128]">Indian Industry</span>
            </h1>

            <h2 className="text-4xl lg:text-4xl font-semibold text-[#faa61a] leading-tight !mt-[10px]">
              Shaping Bharat's Future
            </h2>

            <p className="text-[18px] text-gray-600 max-w-lg">
              The Associated Chambers of Commerce & Industry of India (ASSOCHAM) has been at the forefront of strengthening India's economic landscape for over a century.
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#about-us"
                className="inline-flex items-center gap-2 px-8 py-3.5 hover:bg-[#f59c00] hover:text-white  font-semibold rounded-xl border-2 border-[#f7941d] hover:border-white transition-all duration-300"
              >
                Explore
                <ArrowRight className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* RIGHT SIDE - SLIDER */}
          <div className="relative">
            <div
              className="relative rounded-3xl overflow-hidden shadow-2xl"
              style={{ boxShadow: "2px 2px 2px 2px #9c9999" }}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              <div className="relative h-[430px] lg:h-[440px] rounded-3xl">
                {loading && (
                  <div className="flex items-center justify-center h-full w-full bg-gray-100 animate-pulse text-gray-400 text-sm">
                    Loading...
                  </div>
                )}

                {!loading && cards.length === 0 && (
                  <div className="flex items-center justify-center h-full w-full bg-gray-100 text-gray-400 text-sm">
                    No banners found
                  </div>
                )}

                {!loading && cards.length > 0 && (
                  <div
                    className="flex h-full w-full"
                    onTransitionEnd={handleTransitionEnd}
                    style={{
                      transform: `translateX(-${currentIndex * 100}%)`,
                      transition: isTransitioning
                        ? "transform 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
                        : "none",
                    }}
                  >
                    {cards.map((card, i) => (
                      <div key={i} className="relative h-full w-full shrink-0">
                        <img
                          src={card.img}
                          alt={card.title}
                          className="w-full h-full"
                          loading="eager"
                        />
                        <div className="absolute inset-0" />
                        <div className="absolute bottom-3 left-5 right-5 text-white">
                          <div className="font-serif text-xs lg:text-sm leading-snug bg-black/60 backdrop-blur-md px-2.5 py-1.5 rounded-md inline-block">
                            {card.title}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Left & Right Navigation Arrows */}
                {!loading && cards.length > 0 && (
                  <>
                    <button
                      onClick={handlePrev}
                      className="absolute left-3 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
                      aria-label="Previous slide"
                    >
                      <ChevronLeft className="w-6 h-6 group-hover:scale-110 transition-transform" />
                    </button>
                    <button
                      onClick={handleNext}
                      className="absolute right-3 top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/40 backdrop-blur-sm text-white hover:bg-black/70 hover:scale-110 transition-all duration-300 focus:outline-none group"
                      aria-label="Next slide"
                    >
                      <ChevronRight className="w-6 h-6 group-hover:scale-110 transition-transform" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Floating Ticker */}
      <div className="absolute bottom-0 left-0 w-full z-20 translate-y-1/2 px-6">
        <div className="max-w-8xl mx-auto">
          <div className="bg-[#FFFFFF] backdrop-blur-xl border border-[#FFFFFF] shadow-2xl rounded-2xl overflow-hidden">
            <div className="flex items-center pr-[18px]">
              {/* LIVE UPDATE LABEL */}
              <div className="bg-[#da2128]/50 hover:bg-[#da2128] hover:text-white px-4 py-4 flex items-center gap-2 font-semibold text-xs sm:text-sm whitespace-nowrap rounded-r-2xl shadow-lg min-w-fit ">
                <span className="w-2 h-2 bg-[#FFFFFF] rounded-full animate-pulse" />
                LIVE UPDATES
              </div>

              {/* TICKER */}
              <div className="flex-1 overflow-hidden px-4">
                {tickerLoading && (
                  <div className="py-3 text-sm text-gray-400">Loading updates...</div>
                )}

                {!tickerLoading && horizontalTicker.length === 0 && (
                  <div className="py-3 text-sm text-gray-400">No updates found</div>
                )}

                {!tickerLoading && horizontalTicker.length > 0 && (
                  <div className="flex items-center gap-8 whitespace-nowrap animate-[tickerHorizontal_40s_linear_infinite] hover:[animation-play-state:paused] py-3">
                    {horizontalTicker.map((item, i) => {
                      const Icon = item.icon;

                      return (
                        <a
                          key={i}
                          href={item.link || "#knowledge"}
                          target={item.link ? "_blank" : undefined}
                          rel={item.link ? "noopener noreferrer" : undefined}
                          className="flex items-center gap-2 text-gray-700 hover:text-[#B5121B] transition-colors m-[5px]"
                        >
                          <Icon className="w-4 h-4" />
                          <span className="text-sm font-medium">{item.text}</span>
                          {item.isPdf && (
                            <span className="text-[10px] font-bold text-[#da2128] border border-[#da2128] rounded px-1 leading-4">
                              PDF
                            </span>
                          )}
                        </a>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes tickerHorizontal {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>
  );
}